import { config } from "../../config";

/** The same-origin relative default — Caddy serves /api on the app origin. */
const SAME_ORIGIN_BASE = "/api/v1";

/**
 * API base. Defaults to the same-origin relative path, so no URL is baked into any build and
 * the SPA works unchanged in every environment.
 *
 * `config.apiBaseUrl` (VITE_API_BASE_URL) is the escape hatch for a future topology where the
 * API lives on another origin. It is empty in every current env file, so this resolves to the
 * relative path today — but the wire is now CONNECTED: previously the var was validated,
 * typed, and exposed while nothing read it, so setting it did nothing, silently.
 *
 * Before actually setting it: an off-origin base makes the refresh cookie cross-site, which
 * needs the cookie's Path/SameSite scoping (below) and CORS revisited. Not a drop-in switch.
 */
export const API_BASE_URL = config.apiBaseUrl || SAME_ORIGIN_BASE;

/**
 * Refresh endpoint, relative to {@link API_BASE_URL} (full path: /api/v1/auth/token/refresh/).
 * The httpOnly `dz_refresh` cookie is Path-scoped to /api/v1/auth/, so it only ever flows to
 * auth routes — the refresh call must live under that prefix.
 */
export const AUTH_REFRESH_PATH = "/auth/token/refresh/";
